import { HtmlParser } from '@angular/compiler';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'shortName'
})
export class ShortNamePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {
  }
  transform(fullName: string): any {
    if (fullName === ' '){
      return;
    }

    const namesList = fullName.split(',');
    const avatWidht = namesList.length * 40 ;

    let avatArr = '<div style="width:' + avatWidht + 'px;">';
    namesList.forEach((fName, key) => {
      avatArr +=
        `<div  class="cycle-name" style="float:left">` + fName.split(' ').map(n => n[0]).join('') + `</div>`;
    });
    avatArr += '</div>';
    return this.sanitizer.bypassSecurityTrustHtml(avatArr);
  }
}
